import { createContext, useContext, type ReactNode } from "react";
import type { Event } from "@/lib/event-schema";

const EventContext = createContext<Event | null>(null);

export function EventProvider({ event, children }: { event: Event; children: ReactNode }) {
  return <EventContext.Provider value={event}>{children}</EventContext.Provider>;
}

export function useEvent(): Event {
  const ctx = useContext(EventContext);
  if (!ctx) throw new Error("useEvent must be used inside EventProvider");
  return ctx;
}
